import React from "react";

const Footer = () => {
  return (
    <div>
      <p
        className="text-white text-center fs-5 m-0 p-5 mt-5"
        style={{ backgroundColor: "#161616" }}
      >
        Copyright &copy;{new Date().getFullYear()} All rights reserved | This
        website made by <strong>Kazi naeem Rayhan</strong>
      </p>
    </div>
  );
};

export default Footer;
<h2>footer</h2>;
